import { AdminOnlyItemRestraints } from '@core/shared/restraints';
export class SceneRestraints extends AdminOnlyItemRestraints {
  canViewItem(item) {
    return true;
  }
}